import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";

const Orders = () => {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const ordersCollection = collection(db, "orders");
        const ordersSnapshot = await getDocs(ordersCollection);
        const ordersList = ordersSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        console.log("Fetched orders:", ordersList); // Debugging line
        setOrders(ordersList);
      } catch (error) {
        console.error("Error fetching orders:", error); // Error handling
      }
    };

    fetchOrders();
  }, []);

  return (
    <Container>
      <h1>All Orders</h1>
      <OrdersList>
        {orders.length > 0 ? (
          orders.map((order) => (
            <OrderCard key={order.id}>
              <h2>Order ID: {order.id}</h2>
              <p>
                <strong>Name:</strong> {order.name}
              </p>
              <p>
                <strong>Phone Number:</strong> {order.phoneNumber}
              </p>
              <p>
                <strong>Country:</strong> {order.country}
              </p>
              <p>
                <strong>City:</strong> {order.city}
              </p>
              <p>
                <strong>Address:</strong> {order.address}
              </p>
              <p>
                <strong>Message:</strong> {order.message}
              </p>
              <p>
                <strong>Product Details:</strong>
              </p>
              <pre>{order.productDetails}</pre>
              <p>
                <strong>Total Price:</strong> {order.totalPrice}€
              </p>
              <p>
                <strong>Created At:</strong>{" "}
                {order.timestamp
                  ? new Date(order.timestamp.seconds * 1000).toLocaleString()
                  : "N/A"}
              </p>
            </OrderCard>
          ))
        ) : (
          <p>No orders found.</p>
        )}
      </OrdersList>
    </Container>
  );
};

const Container = styled.div`
  padding: 2em;
  max-width: 1200px;
  margin: auto;
  margin-top: 5em;
`;

const OrdersList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2em;
`;

const OrderCard = styled.div`
  padding: 1em;
  border: 1px solid #ccc;
  border-radius: 10px;
  background: #252525;
  h2 {
    margin-bottom: 0.5em;
    font-size: 15px;
  }
  p {
    margin: 0.5em 0;
  }
  pre {
    background: #313131;
    padding: 1em;
    border-radius: 5px;
    font-family: "Comfortaa", sans-serif;
    font-size: 15px;
    overflow: scroll;
  }
`;

export default Orders;
